export default __webpack_public_path__ + "static/media/T_CarpetTile.0d822ee2.jpg";